// extracted by mini-css-extract-plugin
export default {"main":"hidePanelButton_main__cbvgr","arrow":"hidePanelButton_arrow__tZvIV","arrow_inverted":"hidePanelButton_arrow_inverted__r4tUz"};